import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
    this.payProfileValidation = function () {
        const dictonary = {
            custom: {
                payGroup: {
                    required: () => t.t(dictEnum.LBL_PayGroup) + t.t(dictEnum.WARN_IsRequired)
                },
                payRate: {
                    required: () => t.t(dictEnum.LBL_Rate) + t.t(dictEnum.WARN_IsRequired)
                },
                VCR: {
                    required: () => t.t(dictEnum.LBL_VCR) + t.t(dictEnum.WARN_IsRequired)
                },
                VCE: {
                    required: () => t.t(dictEnum.LBL_VCE) + t.t(dictEnum.WARN_IsRequired)
                },
            }
        };
        Validator.localize('en', dictonary);
    }
}



// WEBPACK FOOTER //
// ./src/components/S080000-Setup/S081900-PayProfile/S081900-PayProfileValidation.js